import { RootState } from '@reducers';

export const selectGeneralQuoteBuy = (state: RootState) => state.generalQuoteBuyRouteReducer;
